<!-- Container to house the different filter buttons to filter members or view them all: -->
<!-- filter buttons visible when there is more than 1 connected student -->
<div *ngIf="displayFamilyFilterButtons" class="bulb-familymember-button-filter-container">
    <div>
        <button [ngClass]="{'bulb-filter-active': showStudent === undefined, 'bulb-filter-inactive': showStudent !== undefined}" class="bulb-familyactivity-buttons bulb-first-button-filter" (click)="showFeed(null)">
            <p transloco="parentAccounts.viewAll.label"
>View All</p>
        </button>

    </div>
    <div *ngFor="let member of familyMembers; let first = first;">

        <button [ngClass]="{'bulb-filter-active': member.isButtonActive, 'bulb-filter-inactive': !member.isButtonActive}" class="bulb-familyactivity-buttons" (click)="showFeed(member)">
            <div *ngIf="!member.getMemberAvatarURL && member.getMemberDisplayName">
              <bulb-user-avatar
                [displayProps]="member.getDisplayProps"
                class="bulb-composite-header-avatar bulb-avatar-small"
                style="transform: translateY(0.2em);border: none"
              ></bulb-user-avatar>
            </div>
            <div *ngIf="member.getMemberAvatarURL">
                <img [src]="member.getMemberAvatarURL" class="bulb-composite-header-avatar bulb-avatar-small">
            </div>
            <p>{{member.getMemberDisplayName}}</p>
        </button>
    </div>
    <div class="hide-for-small-only">
        <br><br>
    </div>
</div>

<!-- message visible if NO students connected & NO activities exist -->
<div *ngIf="!familyMembersToDisplay && !activitiesToDisplay" class="bulb-familymember-view row small-collapse">
  <br><br>
  <family-divider></family-divider>
  <div class="bulb-family-zero-state-container">
    <i class="fas fa-user-friends"></i>
    <h1 class="bulb-family-zero-state-centered" transloco="parentAccounts.zeroStateSeeStudentActivity"
>See Your Student's Activity</h1>
    <p class="bulb-family-zero-state-centered" transloco="parentAccounts.addStudent.zeroState.info"
>To connect the accounts of students in your family, please use their student code to add them to your account.</p>

      <button (click)="scrollToAnchor('bulb-familyView-anchor')" class="bulb-family-zero-state-button" transloco="parentAccounts.addStudent.zeroState.label"
>Add Student</button>
  </div>
</div>

<!-- message visible if students ARE connected but have NO activities -->
<div *ngIf="!activitiesToDisplay && familyMembersToDisplay && !studentHasNoActivities" class="bulb-no-activities-container">
  <br>
  <family-divider></family-divider>
  <p transloco="parentAccounts.studentsNoActivitiesYet"
>
    <span class="bulb-bold">Your students have no activities yet.</span>
    <br>
    This is the space where bulb shows you your students' latest interactions, creations, and publications.</p>
</div>

<!-- message visible if student filter button is active AND student has no activities to display -->
<div *ngIf="studentHasNoActivities" class="bulb-no-activities-container">
  <br>
  <family-divider></family-divider>
  <p transloco="parentAccounts.thisStudentNoActivities"
>
    <span class="bulb-bold">This student has no activities yet.</span>
  </p>
</div>

<!-- Container to house the members' activities and display in in the feed: -->
<!-- visible when activities exist, students do not have to be connected for the feed to be visible -->
<div *ngIf="activitiesToDisplay" class="bulb-familymember-activities-container" infiniteScroll [infiniteScrollDistance]="2"
     [infiniteScrollThrottle]="50" (scrolled)="onScroll(activities)">
    <family-divider></family-divider>
    <div *ngFor="let activity of activities" (click)="setNew(activity)">
        <br>

        <div [ngSwitch]="activity.activityType" class="bulb-memberactivity-rectangle">
          <div class="bulb-activity-container">
            <a [href]="'/' + activity.studentUsername" class="bulb-name-container">
              <div class="bulb-familymember-avatar bulb-activityfeed-avatar">
                  <bulb-user-avatar
                    [displayProps]="activity.displayProps"
                    class="bulb-familymember-default-avatar"
                    *ngIf="!activity.studentAvatarURL"
                  ></bulb-user-avatar>
                  <img *ngIf="activity.studentAvatarURL" [src]="activity.studentAvatarURL">
              </div>
              <p class="bulb-memberactivity-name">{{activity.studentDisplayName}}</p>
            </a>
            <p class="bulb-memberactivity-date">{{activity.date | dateAgo }}</p>
            <!-- The new icon will only be displayed if this content has not been clicked by the user before -->
            <p class="bulb-newicon" *ngIf="activity.isNew" transloco="parentAccounts.new"
>New</p>


            <div *ngSwitchCase="'PAGE_PUBLISHED'"
         class="bulb-activity-description-container"
         (click)="analyticsEvent('PAGE_PUBLISHED')">
            <p transloco="parentAccounts.page.published"
>Published a Page...</p>

              <a [href]="'/u/' + activity.path" *ngIf="activity.path">
                <div class="bulb-activity-innercontainer">
                    <div class="bulb-pageinfo">
                        <h4>{{activity.title}}</h4>
                        <p class="bulb-pagesummary">{{activity.description}}</p>
                        <p class="bulb-pagedescriptor bulb-pagedescriptor-pg" transloco="parentAccounts.page.defined"
>Page</p>
                    </div>
                    <div *ngIf="activity.coverImageURL" class="bulb-pageimage">
                        <img [src]="activity.coverImageURL">
                    </div>
                </div>
              </a>
              <div class="bulb-activity-innercontainer" *ngIf="!activity.path">
                <div class="bulb-pageinfo">
                  <p class="bulb-pagesummary" transloco="parentAccounts.removed">This has been removed.</p>
                </div>
              </div>
            </div>
            <div *ngSwitchCase="'PAGE_CREATED'"
         class="bulb-activity-description-container"
         (click)="analyticsEvent('PAGE_CREATED')">
              <p transloco="parentAccounts.page.created"
>Created a new Page...</p>

              <a [href]="'/u/' + activity.path" *ngIf="activity.path">
                <div class="bulb-activity-innercontainer">
                    <div class="bulb-pageinfo">
                        <h4>{{activity.title}}</h4>
                        <p class="bulb-pagesummary">{{activity.description}}</p>
                        <p class="bulb-pagedescriptor bulb-pagedescriptor-pg" transloco="parentAccounts.page.label"
>Page</p>
                    </div>
                    <div *ngIf="activity.coverImageURL" class="bulb-pageimage">
                        <img [src]="activity.coverImageURL">
                    </div>
                </div>
              </a>
              <div class="bulb-activity-innercontainer" *ngIf="!activity.path">
                <div class="bulb-pageinfo">
                  <p class="bulb-pagesummary" transloco="parentAccounts.removed">This has been removed.</p>
                </div>
              </div>
            </div>
            <div *ngSwitchCase="'COLLECTION_CREATED'"
         class="bulb-activity-description-container"
         (click)="analyticsEvent('COLLECTION_CREATED')">
              <p transloco="parentAccounts.collection.created"
>Created a new Collection...</p>

              <a [href]="'/u/' + activity.path" *ngIf="activity.path">
                <div class="bulb-activity-innercontainer">
                    <div class="bulb-pageinfo">
                        <h4>{{activity.title}}</h4>
                        <p class="bulb-pagesummary">{{activity.description}}</p>
                        <p class="bulb-pagedescriptor" transloco="parentAccounts.collection.label"
>Collection</p>
                    </div>
                    <div *ngIf="activity.coverImageURL" class="bulb-coverimg">
                        <img [src]="activity.coverImageURL">
                    </div>
                </div>
              </a>
              <div class="bulb-activity-innercontainer" *ngIf="!activity.path">
                <div class="bulb-pageinfo">
                  <p class="bulb-pagesummary" transloco="parentAccounts.removed">This has been removed.</p>
                </div>
              </div>
            </div>
            <div *ngSwitchCase="'FAMILY_MEMBER_CONNECTED'"
         class="bulb-activity-description-container"
         (click)="analyticsEvent('FAMILY_MEMBER_CONNECTED')">
              <p transloco="parentAccounts.familyMemberConnected"
>Has been added as a Connection by {{activity.familyDisplayName}}.</p>
            </div>
            <div *ngSwitchCase="'CHILD_DISCONNECTS'"
         class="bulb-activity-description-container"
         (click)="analyticsEvent('CHILD_DISCONNECTS')">
              <p transloco="parentAccounts.childDisconnects"
>Disconnected from {{activity.familyDisplayName}}.</p>
            </div>
          </div>
        </div>
    </div>
</div>
